"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/alert/index.ts
var alert_exports = {};
__export(alert_exports, {
  alertTypes: () => alertTypes,
  default: () => Alert_default
});
module.exports = __toCommonJS(alert_exports);
var import_index3 = require("./index.css");

// src/alert/Alert.tsx
var import_classnames4 = __toESM(require("classnames"));
var import_react = require("react");

// src/closeButton/index.ts
var import_index = require("./index.css");

// src/closeButton/CloseButton.tsx
var import_classnames2 = __toESM(require("classnames"));

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes2
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes2
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/closeButton/closeButton.module.scss
var closeButton_module_default = {
  "closeButton": "closeButton-module__closeButton___Ab4hh",
  "closeButton-dark": "closeButton-module__closeButton-dark___RqPRh",
  "closeButton-light": "closeButton-module__closeButton-light___UBkFK",
  "closeButton-l": "closeButton-module__closeButton-l___Gw8DM",
  "closeButton-m": "closeButton-module__closeButton-m___11tsA",
  "closeButton-s": "closeButton-module__closeButton-s___4zy5d",
  "closeButton-xs": "closeButton-module__closeButton-xs___bjImb"
};

// src/closeButton/CloseButton.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var CloseButton = ({
  onClick,
  size = "m",
  "aria-label": ariaLabel,
  color = "dark",
  id,
  className,
  ...HTMLAttributes2
}) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
  "button",
  {
    type: "button",
    id,
    "aria-label": ariaLabel,
    className: (0, import_classnames2.default)(
      closeButton_module_default.closeButton,
      closeButton_module_default[`closeButton-${color}`],
      closeButton_module_default[`closeButton-${size}`],
      className
    ),
    onClick,
    ...HTMLAttributes2,
    children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { iconName: "close" })
  }
);
var CloseButton_default = CloseButton;

// src/link/index.ts
var import_index2 = require("./index.css");

// src/link/Link.tsx
var import_classnames3 = __toESM(require("classnames"));

// src/common/constants/index.ts
var externalLinkIconProps = {
  iconName: "up-right-from-square",
  iconStyle: "solid"
};

// src/link/link.module.scss
var link_module_default = {
  "heading-xxl": "link-module__heading-xxl___NWhiO",
  "heading-xl": "link-module__heading-xl___reHWW",
  "heading-lg": "link-module__heading-lg___vrkyU",
  "heading-md": "link-module__heading-md___DgXip",
  "heading-sm": "link-module__heading-sm___p4wYS",
  "heading-xs": "link-module__heading-xs___4dzMP",
  "body-one": "link-module__body-one___9dMa8",
  "body-two": "link-module__body-two___A55Jq",
  "body-three": "link-module__body-three___U22yO",
  "body-four": "link-module__body-four___jLkaW",
  "overline-one": "link-module__overline-one___ujSBW",
  "overline-two": "link-module__overline-two___8OvVA",
  "overline-three": "link-module__overline-three___800o1",
  "strong": "link-module__strong___GfpHM",
  "extra-strong": "link-module__extra-strong___Tf0eY",
  "em": "link-module__em___ihSMB",
  "figcaption": "link-module__figcaption___hOiiQ",
  "link": "link-module__link___nBh09",
  "link-primary": "link-module__link-primary___Cgm-i",
  "link-secondary": "link-module__link-secondary___xHFLi",
  "link-l": "link-module__link-l___3mskp",
  "link-m": "link-module__link-m___aQawz",
  "link-s": "link-module__link-s___zlJ-K",
  "link-xs": "link-module__link-xs___Pg8mp"
};

// src/link/Link.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var Link = ({
  children,
  text,
  id,
  className,
  external,
  openInNewTab,
  href = "#",
  disabled,
  onClick,
  size = "m",
  type = "primary",
  role,
  ...HTMLAttributes2
}) => /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
  "a",
  {
    className: (0, import_classnames3.default)(
      link_module_default.link,
      link_module_default[`link-${type}`],
      link_module_default[`link-${size}`],
      className
    ),
    href: !disabled ? href : void 0,
    id,
    onClick: !disabled ? onClick : void 0,
    rel: openInNewTab || external ? "noopener noreferrer" : void 0,
    target: (openInNewTab || void 0) && "_blank",
    role,
    ...disabled ? { "aria-disabled": true } : {},
    ...HTMLAttributes2,
    children: [
      text || children,
      external && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...externalLinkIconProps })
    ]
  }
);
var Link_default = Link;

// src/alert/alert.module.scss
var alert_module_default = {
  "heading-xxl": "alert-module__heading-xxl___KFz-t",
  "heading-xl": "alert-module__heading-xl___Sah5U",
  "heading-lg": "alert-module__heading-lg___C3tUE",
  "heading-md": "alert-module__heading-md___qxqzq",
  "heading-sm": "alert-module__heading-sm___M5Vi-",
  "heading-xs": "alert-module__heading-xs___jflZr",
  "body-one": "alert-module__body-one___nK1GQ",
  "body-two": "alert-module__body-two___CsJVf",
  "body-three": "alert-module__body-three___u265L",
  "body-four": "alert-module__body-four___ZRtqs",
  "overline-one": "alert-module__overline-one___07VjC",
  "overline-two": "alert-module__overline-two___VjFIk",
  "overline-three": "alert-module__overline-three___86CXQ",
  "strong": "alert-module__strong___nQfXJ",
  "extra-strong": "alert-module__extra-strong___kSuK0",
  "em": "alert-module__em___U9Y48",
  "figcaption": "alert-module__figcaption___GOcmX",
  "alert": "alert-module__alert___tzTnQ",
  "alertContentContainer": "alert-module__alertContentContainer___OuNdR",
  "alert-primary": "alert-module__alert-primary___4vRsD",
  "alert-success": "alert-module__alert-success___O5vlm",
  "alert-danger": "alert-module__alert-danger___hRxuR",
  "alert-warning": "alert-module__alert-warning___UDnBT",
  "alert-info": "alert-module__alert-info___5yPvt",
  "alert-gray": "alert-module__alert-gray___OSVhy",
  "alert-l": "alert-module__alert-l___Pp288",
  "alert-m": "alert-module__alert-m___ibdWz",
  "alert-s": "alert-module__alert-s___iKkxQ",
  "alert-xs": "alert-module__alert-xs___N52gK"
};

// src/alert/Alert.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var alertTypes = {
  primary: "primary",
  success: "success",
  danger: "danger",
  warning: "warning",
  info: "info",
  gray: "gray"
};
var getDefaultAlertIconFromType = (type) => {
  const iconMap = {
    success: { iconName: "check-circle" },
    danger: { iconName: "circle-xmark" },
    warning: { iconName: "exclamation-circle" },
    info: { iconName: "circle-info" }
  };
  return iconMap[type];
};
var Alert = ({
  text,
  showIcon = true,
  icon,
  link,
  className,
  onClose,
  closeLabel = "Close alert",
  isImmediateImportance = true,
  type = "primary",
  size = "m",
  ...HTMLAttributes2
}) => {
  const iconToRender = (0, import_react.useMemo)(
    () => icon || getDefaultAlertIconFromType(type),
    [icon, type]
  );
  const closeButtonSize = size === "l" ? "l" : "m";
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(
    "div",
    {
      className: (0, import_classnames4.default)(
        alert_module_default.alert,
        alert_module_default[`alert-${type}`],
        alert_module_default[`alert-${size}`],
        className
      ),
      role: isImmediateImportance ? "alert" : "status",
      ...HTMLAttributes2,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: alert_module_default.alertContentContainer, children: [
          showIcon && iconToRender && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(FontAwesomeV6Icon_default, { ...iconToRender }),
          /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("span", { className: alert_module_default.alertText, children: [
            text,
            link && /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(import_jsx_runtime4.Fragment, { children: [
              "\xA0\xA0",
              /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(Link_default, { ...link, size })
            ] })
          ] })
        ] }),
        onClose && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
          CloseButton_default,
          {
            "aria-label": closeLabel,
            onClick: onClose,
            size: closeButtonSize
          }
        )
      ]
    }
  );
};
var Alert_default = Alert;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  alertTypes
});
//# sourceMappingURL=index.js.map